// extracted by mini-css-extract-plugin
export var quillEditor = "_ju-1";
export var variable = "_ju-0";